import WingHero from "../components/WingHero";
import WingPrograms from "../components/WingPrograms";
import WingPathwayNav from "../components/WingPathwayNav";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { wingDetails } from "@/mocks/programsData";

const wingData = wingDetails.find((w) => w.wing === "Expo Wing")!;

export default function ExpoWingPage() {
  return (
    <main className="min-h-screen">
      <WingHero
        badge="Expo Wing"
        title="Expo Wing"
        subtitle={wingData.tagline}
        description={wingData.description}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      {/* What Is Section */}
      <section className="bg-tie-grey-light py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-10">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-violet-500/10 mb-4 md:mb-6">
                  <span className="text-xs font-semibold text-violet-600 uppercase tracking-wider">
                    / What This Wing Does
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                  Where Innovation Meets the Market
                </h2>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="space-y-4 md:space-y-5">
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  The Expo Wing creates the commercial and collaborative marketplace for textile innovation.
                  It matches solution providers with factories needing proven technologies, and showcases
                  breakthrough innovations to brands, investors, and sustainability teams from around the world.
                </p>
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  The flagship Textile Innovation Expo at ICCB, Dhaka, brings together 200+ exhibitors and
                  5,000+ factory delegates for three days of live demonstrations, B2B matchmaking, and deal-making.
                  Concurrent expos dedicated to denim, materials, automation, and sustainability run alongside —
                  ensuring every vertical finds its audience.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { label: "Exhibitors", value: "200+" },
                  { label: "Factory Delegates", value: "5,000+" },
                  { label: "Days", value: "3" },
                  { label: "Concurrent Expos", value: "4" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 md:p-5 rounded-xl bg-white border border-tie-grey-dark">
                    <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy mb-1">{stat.value}</p>
                    <p className="text-xs md:text-sm text-tie-text-muted">{stat.label}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <WingPrograms
        title="Programmes in the Expo Wing"
        programs={wingData.items}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      <WingPathwayNav />
    </main>
  );
}